var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.tabsName,
            callback: function ($$v) {
              _vm.tabsName = $$v
            },
            expression: "tabsName",
          },
        },
        _vm._l(_vm.tabsConfig, function (tab) {
          return _c(
            "el-tab-pane",
            { key: tab.name, attrs: { label: tab.label, name: tab.name } },
            [
              tab.tips
                ? _c("div", { staticClass: "tips" }, [
                    _c("i", { staticClass: "el-icon-info icon" }),
                    _c("span", [_vm._v(_vm._s(tab.tips))]),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _vm.tabsName === "1"
        ? [
            _c(
              "el-table",
              {
                staticClass: "table-wrap",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  border: "",
                  "header-cell-style": _vm.headerCellStyle,
                  "row-style": _vm.rowStyle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "brand_name", label: "品牌信息" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "order_num", label: "订单数" },
                }),
                _c(
                  "el-table-column",
                  { attrs: { prop: "amount" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费点数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "订单消费点数 = 卡消费点数 - 退回卡点数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "consume_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " + _vm._s(row.consume_rate + "%") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1790288032
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费占比")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "当前消费点数 / 总计消费点数 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "cost_a0" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "卡实际分摊真实成本价A0",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "cost_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cost_rate + "%") + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3296176327
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本率")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "成本 / 卡实际分摊抵扣金额 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination__style" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    "page-sizes": [20, 50, 100, 300, 500, 1000],
                    "page-size": _vm.pages.pagesize,
                    "current-page": _vm.pages.page,
                    total: _vm.pages.totalCount,
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "keep-alive",
        [
          _vm.tabsName === "3"
            ? _c("provinceDetailStatistics", {
                ref: "provinceDetailStatistics",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  entry: _vm.entry,
                  "order-id":
                    (_vm.originParams && _vm.originParams.order_id) || "",
                  "category-id":
                    (_vm.originParams && _vm.originParams.category_id) || "",
                  "order-type":
                    (_vm.originParams && _vm.originParams.type) || "",
                },
                on: { "jump-city": _vm.onJumpCityStatistics },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _vm.tabsName === "2"
            ? _c("cityDetailStatistics", {
                ref: "cityDetailStatistics",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  entry: _vm.entry,
                  "order-id":
                    (_vm.originParams && _vm.originParams.order_id) || "",
                  "category-id":
                    (_vm.originParams && _vm.originParams.category_id) || "",
                  "order-type":
                    (_vm.originParams && _vm.originParams.type) || "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }